import * as styles from "./Logo.module.less";

/**
 * TypeBlind wordmark — "The Caret". Set in IBM Plex Mono, lowercase:
 * `type` + a blinking block caret + `blind`. The caret (accent-colored) is a
 * text cursor that hides "where your eyes shouldn't be" — between the words.
 */
export function Logo() {
  return (
    <div className={styles.root} aria-label="TypeBlind">
      <span className={styles.wordmark}>
        <span className={styles.type}>type</span>
        <span className={styles.caret} aria-hidden="true" />
        <span className={styles.blind}>blind</span>
      </span>
    </div>
  );
}
